export default __webpack_public_path__ + "static/media/post_03mar.ee6607c2.png";